<template>
  <div>
    <div class="edit-info">
      <div class="edit-main">
        <div class="avatar">
          <div class="pic">
            <a-upload
              v-model:file-list="fileList"
              name="file"
              class="avatar-uploader"
              :multiple="false"
              :show-upload-list="false"
              :action="actionUrl"
              :before-upload="beforeUpload"
              @change="handleChange"
              accept=".jpg,.png,.gif,.jpeg,.JPG,.PNG,.GIF,.JPEG"
            >
              <img
                v-if="userInfo.imgUrl"
                :src="imgSiteUrl + userInfo.imgUrl"
                alt=""
              />
              <img v-else src="~@/assets/img/head1.png" alt="" />
              <div class="text">修改我的头像</div>
            </a-upload>
            <div style="fontSize: 14px; color: #969696">
              支持PNG、JPE、GIF、JPEG格式，头像不大于5M
            </div>
          </div>
        </div>
        <a-row style="float: right">
          <router-link to
            ><a-col @click="$router.back(-1)">返回我的主页></a-col></router-link
          >
        </a-row>
        <div style="margin-top: 60px"></div>
        <div class="right">
          <a-row :gutter="[16, 16]">
            <a-col :span="3" class="label">用户名</a-col>
            <a-col :span="12"
              ><a-input
                v-model:value.trim()="userInfo.userName"
                :maxlength="15"
            /></a-col>
            <a-col :span="9" class="tips"
              >2-30个字符，支持中英文、数字、“_”或减号</a-col
            >
          </a-row>
          <div v-for="(item, key) in positionList" :key="item.ord + key">
            <div class="blank" style="height: 30px"></div>
            <a-row :gutter="[16, 16]">
              <a-col :span="2" class="label"
                ><span v-show="key === 0">职务信息</span></a-col
              >
              <a-col :span="1" class="sort">{{ item.ord }}</a-col>
              <a-col :span="6">
                <a-input
                  placeholder="请输入单位名称"
                  v-model:value.trim()="item.group_name"
                />
              </a-col>
              <a-col :span="6">
                <a-input
                  placeholder="请输入职务名称"
                  v-model:value.trim()="item.position"
                />
              </a-col>
              <a-col :span="2">
                <div class="tip">
                  <plus-circle-outlined v-if="key === 0" @click="addPos" />
                  <minus-circle-outlined v-else @click="removePos(key)" />
                </div>
              </a-col>
            </a-row>
          </div>

          <div style="height: 1px; margin: 45px 0; background: #e9e9e9"></div>
          <a-row :gutter="[16, 16]">
            <a-col :span="3" class="label">最高学历</a-col>
            <a-col :span="6">
              <a-select
                v-model:value.trim()="userInfo.education"
                placeholder="下拉选择学历"
                style="width: 100%"
              >
                <a-select-option
                  v-for="item in eduList"
                  :key="item"
                  :value="item"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </a-col>
            <a-col :span="6">
              <a-input
                v-model:value.trim()="userInfo.school"
                placeholder="请输入学校名称"
              />
            </a-col>
            <a-col :span="6">
              <a-input
                v-model:value.trim()="userInfo.major"
                placeholder="请输入专业名称"
              />
            </a-col>
          </a-row>

          <div style="height: 1px; margin: 45px 0; background: #e9e9e9"></div>
          <a-row :gutter="[16, 16]">
            <a-col :span="3" class="label">兴趣选择</a-col>
            <a-col :span="21">
              <div class="tags" style="margin-left: -20px">
                <span v-show="tags.length > 0">
                  <a-badge
                    v-for="(tag, index) in tags"
                    :key="tag.topicId"
                    style="margin-left: 20px"
                  >
                    <template #count>
                      <close-circle-filled
                        style="color: #e75934"
                        @click="handleClose(index)"
                      />
                    </template>
                    <a-button
                      type="primary"
                      style="
                        border-color: #e8e8e8;
                        color: #333;
                        border-radius: 2px;
                      "
                      ghost
                      >{{ tag.topicName }}</a-button
                    >
                  </a-badge>
                </span>

                <div class="search">
                  <a-input-search
                    type="text"
                    size="small"
                    v-model:value.trim()="tagName"
                    placeholder="输入内容"
                    @change="changeTagName"
                    v-show="tags.length <= 4"
                  />
                  <div class="list" v-show="selectList.length >= 0">
                    <div
                      class="item"
                      v-for="item in selectList"
                      :key="item.topicId"
                      @click.stop="selectTag(item)"
                    >
                      {{ item.topicName }}
                    </div>
                  </div>
                </div>

                <span v-show="tags.length <= 4"> ({{ tags.length }}/5) </span>
              </div>
            </a-col>
          </a-row>
          <div style="height: 1px; margin: 45px 0; background: #efefef"></div>

          <a-row :gutter="[16, 16]">
            <a-col :span="3" class="label">一句话介绍</a-col>
            <a-col :span="18">
              <a-input
                style="color: #333"
                v-model:value.trim()="userInfo.presonalProfile"
                show-count
                :maxlength="30"
                placeholder="这个用户很神秘，暂时没有留下介绍哦～"
              />
            </a-col>
          </a-row>
        </div>
        <div class="save">
          <a-button type="primary" @click="saveInfo">保存</a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  onBeforeUnmount,
} from "vue";
import config from "../until/configs";
import { useRouter } from "vue-router";
import Http from "../until/http";
import { getCookie, isName, messageTips, setLocalItem } from "../until/tools";
import {
  PlusCircleOutlined,
  MinusCircleOutlined,
  CloseCircleFilled,
} from "@ant-design/icons-vue";
const eduList = [
  "博士",
  "硕士",
  "本科",
  "博士在读",
  "硕士在读",
  "本科在读",
  "其他",
];
export default defineComponent({
  components: { PlusCircleOutlined, MinusCircleOutlined, CloseCircleFilled },
  setup() {
    const router = useRouter();
    const state = reactive({
      fileList: [],
      actionUrl: config.personUploadImage + "?sid=" + getCookie("z_sid"),
      imgSiteUrl: config.imgSiteUrl,
      positionList: [
        {
          ord: 1,
          group_name: "",
          position: "",
        },
      ],
      inputVisible: false,
      tags: [],
      selectList: [],
      tagName: "",
      userInfo: {},
    });

    const beforeUpload = (file) => {
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        messageTips("图像必须小于5M!", 1);
        return false;
      }
      return isLt2M;
    };

    const handleChange = ({ file }) => {
      if (file.status === "done") {
        if (file.response.url) {
          Http.updateHeaderImg().then(() => {
            Http.getUserInfo().then((res) => {
              if (res.userInfo) {
                setLocalItem("userInfo", res.userInfo);
                Object.assign(state, {
                  userInfo: res.userInfo,
                });
                router.go(0);
              }
            });
          });
        }
      }
    };

    const addPos = () => {
      let obj = {
        ord: state.positionList.length + 1,
        group_name: "",
        position: "",
      };
      Object.assign(state, {
        positionList: [...state.positionList, obj],
      });
    };

    const removePos = (key) => {
      let arr = [...state.positionList];
      arr.splice(key, 1);
      Object.assign(state, { positionList: arr });
    };

    const saveInfo = () => {
      if (state.userInfo.userName === "") {
        messageTips("请填写用户名！", 2);
        return false;
      } else if (!isName(state.userInfo.userName)) {
        messageTips("昵称支持中英文、数字、“_”或减号", 2);
        return;
      }
      // if (state.userInfo.userName < 2 || state.userInfo.userName > 30) {
      //   messageTips("昵称输入2-30个字符", 2);
      //   return;
      // }

      // let blankItem = null;
      // state.positionList.some((item) => {
      //   if (item.group_name.trim() === "" || item.position.trim() === "") {
      //     blankItem = item;
      //     return true;
      //   }
      // });
      // if (blankItem) {
      //   if (blankItem.group_name.trim() === "") {
      //     messageTips("输入单位名称", 2);
      //     return false;
      //   }
      //   if (blankItem.position.trim() === "") {
      //     messageTips("请输入职务名称", 2);
      //     return false;
      //   }
      // }
      let params = {
        userId: state.userInfo.userId,
        nickname: state.userInfo.userName,
        positions: state.positionList,
        education: state.userInfo.education,
        school: state.userInfo.school,
        major: state.userInfo.major,
        personalProfile: state.userInfo.presonalProfile || "",
      };
      if (state.tags.length > 0) {
        params.userTopic = state.tags;
      }

      Http.updateUserInfo({ params: JSON.stringify(params) }).then((res) => {
        if (res) {
          if (res.success) {
            messageTips(res.message, 3);
            getUserInfo();
          } else {
            messageTips(res.message, 1);
          }
        }
      });
    };

    const handleClose = (index) => {
      let arr = [...state.tags];
      arr.splice(index, 1);
      Object.assign(state, { tags: arr });
    };

    const selectTag = (item) => {
      let index = -1;
      state.tags.some((value, key) => {
        if (value.topicId === item.topicId) {
          index = key;
          return true;
        }
      });
      if (index === -1) {
        let arr = [...state.tags, item];
        Object.assign(state, { tags: arr });
      }
      setTimeout(() => {
        Object.assign(state, {
          tagName: "",
        });
      }, 30);
      clickEvent();
    };

    var timeout = null;
    var currentValue = "";
    function fatch(value) {
      if (value === "") {
        return false;
      }
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      currentValue = value;

      function fake() {
        Http.getTopics({ topicName: currentValue }).then((res) => {
          if (res.topicList) {
            Object.assign(state, { selectList: res.topicList });
          }
        });
      }
      timeout = setTimeout(fake, 1000);
    }

    const changeTagName = () => {
      fatch(state.tagName);
    };

    function clickEvent() {
      Object.assign(state, {
        inputVisible: false,
        // tagName: "",
        selectList: [],
      });
    }

    const getUserInfo = () => {
      Http.getUserInfo().then((res) => {
        if (res && res.userInfo) {
          Object.assign(state, {
            userInfo: res.userInfo,
          });
          setLocalItem("userInfo", res.userInfo);
          if (res.userInfo.userPositions) {
            Object.assign(state, {
              positionList: res.userInfo.userPositions,
            });
          }
          if (res.userInfo.userTopic) {
            Object.assign(state, {
              tags: res.userInfo.userTopic,
            });
          }
        }
      });
    };

    onMounted(() => {
      // document.addEventListener("click", clickEvent);
      let sid = getCookie("z_sid");
      if (!sid) {
        router.push("/login");
        return false;
      }
      getUserInfo();
    });

    onBeforeUnmount(() => {
      // document.removeEventListener("click", clickEvent);
    });

    return {
      ...toRefs(state),
      beforeUpload,
      handleChange,
      eduList,
      addPos,
      removePos,
      saveInfo,
      handleClose,
      selectTag,
      changeTagName,
    };
  },
});
</script>
<style lang="scss">
.search {
  display: inline-block;
  margin-left: 20px;
  width: 180px;
  position: relative;
  top: -5px;
  .ant-input-sm {
    height: 30px;
    display: inline-block;
  }
}
</style>
<style lang="scss" scoped>
@import "../scss/editInfo.scss";
.ant-input-placeholder {
  color: red;
}
</style>